import List from './List';
import Show from './Show';
import Edit from './Edit';
export { List, Show, Edit }
export default { List, Show, Edit}
